export default function toCamelCase(input: string): string {
	const withoutSpacesAndHyphens = input.replace(/\s+/g, "").replace(/-/g, "")
	const firstLetterLowercased = withoutSpacesAndHyphens
		.charAt(0)
		.toLowerCase()
	return firstLetterLowercased + withoutSpacesAndHyphens.slice(1)
}
